import React, { useEffect, useState } from 'react';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import useTranslate from '../customHooks/useTranslate';

const getLabelKey = (arrayOptions, key) => {
    return arrayOptions.map(opt => {
        return { ...opt, label: opt[key] || opt.Caption || opt.Name };
    });
};

const SelectComponent = props => {
    const {
        options = [],
        optionsLabelKey = 'label',
        idKey = 'Id',
        required,
        label,
        value,
        id,
        ...restProps
    } = props;
    const translate = useTranslate();
    const [optionsSelect, setOptionsSelect] = useState(
        getLabelKey(options, optionsLabelKey)
    );

    useEffect(() => {
        const newOptions = getLabelKey(options, optionsLabelKey);
        setOptionsSelect(newOptions);
    }, [options, optionsLabelKey]);
    return (
        <FormControl sx={{ width: '100%' }} required={required}>
            {label && <InputLabel>{translate(label)}</InputLabel>}
            <Select
                size='small'
                value={value ? value : ''}
                name={id}
                {...restProps}
            >
                {!required && <MenuItem key={0} sx={{ height: '33px' }} />}
                {optionsSelect.map(option => {
                    return (
                        <MenuItem
                            key={option[idKey]}
                            value={parseInt(option[idKey])}
                        >
                            {option.label}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
};

export default SelectComponent;
